"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UILockBadge;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _I18n = _interopRequireDefault(require("I18n"));

var _IconConstants = require("../icon/IconConstants");

var _UIIcon = _interopRequireDefault(require("../icon/UIIcon"));

var _lazyEval = _interopRequireDefault(require("../utils/lazyEval"));

var _createLazyPropType = _interopRequireDefault(require("../utils/propTypes/createLazyPropType"));

function UILockBadge(_ref) {
  var className = _ref.className,
      size = _ref.size,
      titleText = _ref.titleText,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["className", "size", "titleText"]);
  var classes = (0, _classNames.default)('private-lock-badge', className);
  return _react.default.createElement(_UIIcon.default, (0, _extends2.default)({}, rest, {
    "aria-label": (0, _lazyEval.default)(titleText),
    className: classes,
    name: "locked",
    size: size
  }));
}

UILockBadge.propTypes = {
  size: _react.PropTypes.oneOfType([_react.PropTypes.oneOf(Object.keys(_IconConstants.ICON_SIZES)), _react.PropTypes.number]),
  titleText: (0, _createLazyPropType.default)(_react.PropTypes.string).isRequired
};
UILockBadge.defaultProps = {
  titleText: function titleText() {
    return _I18n.default.text('salesUI.UILockBadge.title');
  }
};
UILockBadge.displayName = 'UILockBadge';
module.exports = exports.default;